import Accord from './Accord'
import CategoriesMenu from './CategoriesMenu'
import Cloner from './Cloner'
import ConnectLine from './ConnectLine'
import ConnectLinePoint from './ConnectLinePoint'
import ContractSlider from './ContractSlider'
import Events from './Events'
import FileInput from './FileInput'
import FixedMenu from './FixedMenu'
import Flickity from './Flickity'
import Gallery from './Gallery'
import LoadMore from './LoadMore'
import Map from './Map'
import Menu from './Menu'
import SampleComponent from './SampleComponent'
import Search from './Search'
import SearchOpener from './SearchOpener'
import Sizer from './Sizer'
import Submenu from './Submenu'
import Tabs from './Tabs'

const Components = {
    SampleComponent: SampleComponent,
    Accord: Accord,
    CategoriesMenu: CategoriesMenu,
    Cloner: Cloner,
    ConnectLine: ConnectLine,
    ConnectLinePoint: ConnectLinePoint,
    ContractSlider: ContractSlider,
    Events: Events,
    FileInput: FileInput,
    FixedMenu: FixedMenu,
    Flickity: Flickity,
    LoadMore: LoadMore,
    Gallery: Gallery,
    Map: Map,
    Menu: Menu,
    Search: Search,
    SearchOpener: SearchOpener,
    Sizer: Sizer,
    Submenu: Submenu,
    Tabs: Tabs,
}

export default Components



// WEBPACK FOOTER //
// ./components/index.js